import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import { Select } from '../../components/ui/Input';
import { recomendacaoCompraApi } from '../../api/recomendacaoCompra';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

const OPCOES_MESES = [
  { value: '1', label: 'Último 1 mês' },
  { value: '3', label: 'Últimos 3 meses' },
  { value: '6', label: 'Últimos 6 meses' },
  { value: '12', label: 'Últimos 12 meses' }
];

function tomUrgencia(item) {
  if (item.estoque_atual <= 0) return 'perigo';
  if (item.estoque_minimo > 0 && item.estoque_atual <= item.estoque_minimo) return 'perigo';
  return 'aviso';
}

export default function RecomendacaoCompraList() {
  useTituloPagina('Recomendação de Compra');
  const [meses, setMeses] = useState('3');
  const [itens, setItens] = useState([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    setCarregando(true);
    recomendacaoCompraApi.listar(meses).then(setItens).catch(() => {}).finally(() => setCarregando(false));
  }, [meses]);

  return (
    <div>
      <Card style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ fontSize: 13, color: COLORS.textMid, margin: 0, maxWidth: 560 }}>
            Cruza o quanto cada produto vendeu no período com o estoque atual e sugere uma quantidade de compra —
            ordenado do mais urgente (vende muito e tem pouco estoque) pro menos urgente.
          </p>
          <Select label="Período de análise" options={OPCOES_MESES} value={meses} onChange={e => setMeses(e.target.value)} style={{ width: 200 }} />
        </div>
      </Card>

      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Produto</th>
              <th style={{ padding: 10 }}>Vendido no Período</th>
              <th style={{ padding: 10 }}>Média Mensal</th>
              <th style={{ padding: 10 }}>Estoque Atual</th>
              <th style={{ padding: 10 }}>Estoque Mínimo</th>
              <th style={{ padding: 10 }}>Qtd. Recomendada</th>
              <th style={{ padding: 10 }} />
            </tr>
          </thead>
          <tbody>
            {itens.map(item => (
              <tr key={item.produto_id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10 }}>
                  <strong>{item.codigo}</strong> — {item.nome}
                  {item.codigo_fabricante && <span style={{ color: COLORS.textLight }}> · {item.codigo_fabricante}</span>}
                </td>
                <td style={{ padding: 10 }}>{item.total_vendido.toLocaleString('pt-BR')}</td>
                <td style={{ padding: 10 }}>{item.media_mensal.toFixed(1)}</td>
                <td style={{ padding: 10, fontWeight: 600 }}>{item.estoque_atual.toLocaleString('pt-BR')}</td>
                <td style={{ padding: 10 }}>{item.estoque_minimo.toLocaleString('pt-BR')}</td>
                <td style={{ padding: 10, fontWeight: 700, color: COLORS.primary }}>{item.quantidade_recomendada.toLocaleString('pt-BR')}</td>
                <td style={{ padding: 10 }}><Badge tom={tomUrgencia(item)}>{tomUrgencia(item) === 'perigo' ? 'Urgente' : 'Atenção'}</Badge></td>
              </tr>
            ))}
            {!carregando && itens.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma recomendação de compra no momento.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
